import { userDataStorageKey } from '../../../config'

// Hydrate user from localStorage at module-load time so the globalMetadata
// getter (translations, appSkin, statuses, dateFormat, …) returns cached data
// before any HTTP call completes. The store is then refreshed by the diff
// response from /auth/token/issue, /auth/signup or /v1/settings/account/{id}.
function loadCachedUser() {
  try {
    const raw = localStorage.getItem(userDataStorageKey)
    if (!raw) return {}
    const parsed = JSON.parse(raw)
    return parsed || {}
  } catch (e) {
    return {}
  }
}

export default {
  user: loadCachedUser(),
  token: null,
}
